import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { completeShipments, setCompleteShipmentIds } from "../../../features/loadList/loadListSlice";
import { showModal } from "../../../features/modal/modalSlice";
import { useScrollLock } from "../../../hooks/useScrollLock";
import Btn from "../../shared/button/Btn";
import SmallSpinner from "../../shared/spinners/SmallSpinner";

const Container = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.6);

  .modal {
    width: min(500px, 100%);
    padding: 30px;
    border-radius: 10px;
    background: ${({theme}) => theme.mainBgColor};
    color: ${({theme}) => theme.mainTextColor};
  }

  .title {
    margin-bottom: 12px;
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-xl);
  }

  .description {
    margin-bottom: 28px;
    line-height: 1.5;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }

  @media (max-width: 520px) {
    .modal {
      padding: 22px;
    }

    .actions {
      flex-direction: column;
    }

    .actions button {
      width: 100%;
    }
  }
`;

const CompleteShipmentsPermissionModal = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const {lockScroll, unlockScroll} = useScrollLock();
  const {completeShipmentIds, isLoadingCompleteShipments} = useSelector(state => state.loadList);
  const {modalLocation} = useSelector(state => state.modal);

  useEffect(() => {
    lockScroll();
    return () => unlockScroll();
  }, [lockScroll, unlockScroll]);

  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
      dispatch(setCompleteShipmentIds([]));
    }
  }, [dispatch, location.pathname, modalLocation]);

  const handleClose = () => {
    if (isLoadingCompleteShipments) return;
    dispatch(showModal(null));
    dispatch(setCompleteShipmentIds([]));
  };

  const handleConfirm = async () => {
    if (completeShipmentIds.length === 0 || isLoadingCompleteShipments) return;
    await dispatch(completeShipments({shipmentIds: completeShipmentIds}));
  };

  return (
    <Container>
      <div className="modal" onClick={(event) => event.stopPropagation()}>
        <div className="title">Sevkiyatı Tamamla</div>
        <div className="description">
          {completeShipmentIds.length > 1
            ? `${completeShipmentIds.length} seçili sevkiyatı tamamlamak istediğinize emin misiniz?`
            : "Bu sevkiyatı tamamlamak istediğinize emin misiniz?"}
        </div>
        <div className="actions">
          <Btn width="130px" color="#E85446" bgColor="transparent" handleClick={handleClose} isDisabled={isLoadingCompleteShipments}>
            Vazgeç
          </Btn>
          <Btn width="190px" color="#fff" bgColor="#E85446" borderColor="transparent" handleClick={handleConfirm} isDisabled={isLoadingCompleteShipments}>
            {isLoadingCompleteShipments ? <SmallSpinner size="20px" color="#fff" bgColor="#E85446" /> : "Onayla ve Tamamla"}
          </Btn>
        </div>
      </div>
    </Container>
  );
};

export default CompleteShipmentsPermissionModal;
